var E="GUILD_SERVICE_VERSION";export{E as VERSION_ENV_KEY};
//# sourceMappingURL=VERSION_ENV_KEY.js.map
